import { useSelector } from 'react-redux'
import { RootState } from '../redux'

export default function useLevels() {
  return useSelector((state: RootState) => state.levels.levels)
}
